
import { FTextField, FormatFunction, ParseFunction } from '@fkui/vue';
import { WHITESPACE_PATTERN, formatNumber, isEmpty } from '@fkui/logic';
import { PropOptions } from 'vue';

function numberFormatter(value: string): string | undefined {
    if (!isEmpty(value)) {
        const number = Number(value.replace(/\s/g, ''));
        return formatNumber(number)?.replace(WHITESPACE_PATTERN, ' ');
    }
    return undefined;
}

function numberParser(value: string): string | undefined {
    if (isEmpty(value)) {
        return undefined;
    }
    return value;
}

export default FTextField.extend({
    name: 'BtNumberField',
    props: {
        formatter: {
            type: Function,
            required: false,
            default: numberFormatter,
        } as PropOptions<FormatFunction<string>>,
        parser: {
            type: Function,
            required: false,
            default: numberParser,
        } as PropOptions<ParseFunction<number>>,
    },
});
